import {
  BACKEND_KEYS,
  modeOfPaymentValues,
  smartCameraKey,
  sixMonthsFree,
  tsbSecurityOffersObject,
  temperatureSensor,
  easyTemperatureSensor,
  easyFiveYearTemperatureSensor
} from '../../../utils/constant';
import { getLocalizedStrings, getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
const { secureBusinessStep } = BACKEND_KEYS;

export const getFieldPriceOrLabel = (
  fields,
  fieldValue,
  shouldReturnPrice = true
) => {
  for (let i = 0; i < fields.length; i += 1) {
    const field = fields[i];
    if (field.fields.formStepFields && field.fields.formStepFields.length) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.formStepFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.easyPaymentFields &&
      field.fields.easyPaymentFields.length
    ) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.easyPaymentFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.fiveYearEasyPaymentFields &&
      field.fields.fiveYearEasyPaymentFields.length
    ) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.fiveYearEasyPaymentFields,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (field.fields.options && field.fields.options.length) {
      const optionLabelOrPriceValue = getFieldPriceOrLabel(
        field.fields.options,
        fieldValue,
        shouldReturnPrice
      );
      if (optionLabelOrPriceValue) {
        return optionLabelOrPriceValue;
      }
    }
    if (
      field.fields.name === fieldValue ||
      field.fields.value === fieldValue ||
      field.fields.backendKey === fieldValue
    ) {
      if (!shouldReturnPrice) {
        return field.fields.label;
      }
      if (
        field.fields.price ||
        field.fields.monthlyPayment ||
        field.fields.fiveYearEasyPayment
      ) {
        return {
          oneTime: field.fields.price || 0,
          monthly: field.fields.monthlyPayment || 0,
          monthlyFiveYear: field.fields.fiveYearEasyPayment || 0
        };
      }
    }
  }
  return null;
};

export default (orderData, steps, localizedStrings) => {
  const {
    quoteSummary: {
      secureBusinessPackages: { Monitor },
      secureBusinessOffers: {
        twentyOffWireline,
        zeroInstallation,
        hardwareCredit,
        threeMonthFree,
        tenOffMpp,
        twentyOffMpp,
        installationOff,
        tenOFFWireless,
        tenOFFWireline,
        tenOffWirelene,
        twentyOffWirelineTSB,
        zeroInstallationTSB,
        threeMonthFreeTSB,
        tenOffMppTSB,
        twentyOffMppTSB,
        installationOffTSB,
        tenOFFWirelessTSB,
        tenOFFWirelineTSB,
        tenOffWireleneTSB,
        sixMonthFree,
        sixMonthFreeTSB,
        fivePercenDiscount,
        threeDollarOff
      }
    }
  } = getLocalizedStrings();
  const locale = getLocale();

  const {
    WLS: { _tenDollarOff }
  } = locale === 'en-US' ? EN : FR;
  const product = {
    selectedEquipments: [],
    includedEquipments: [],
    additionalEquipments: [],
    additionalEquipmentsEasyPayments: [],
    limitedTimeOffers: [],
    regularOffers: [],
    features: []
  };

  let oneTime = 0;
  let monthly = 0;
  let monthlyFiveYear = 0;
  let serviceFee = 0;
  let additionalEquipmentsTotal = 0;
  const {
    fields: { formStepFields }
  } = steps.find(s => s.fields.backendKey === secureBusinessStep);
  if (formStepFields && formStepFields.length) {
    const selectedPackage = orderData.telusSecureBusinessSecurityPackage;
    const selectedPackagePrice = getFieldPriceOrLabel(
      formStepFields,
      selectedPackage
    );
    oneTime += selectedPackagePrice.oneTime;
    monthly += selectedPackagePrice.monthly;
    monthlyFiveYear += selectedPackagePrice.monthlyFiveYear;

    product.securityPackage = {
      value: selectedPackage,
      qty: 1,
      prices: selectedPackagePrice
    };
    const selectedtsbTerm = (orderData && orderData.secureBusinessTerm) || '';
    product.tsbTerm = {
      value: selectedtsbTerm,
      qty: '',
      prices: {
        monthly: '',
        oneTime: '',
        monthlyFiveYear: ''
      }
    };

    const ADDITIONAL_EQUIPMENT = 'AdditionalEquipment';
    const INCLUDED_EQUIPMENT = 'IncludedEquipment';
    const INCLUDED_EQUIPMENT_SELECTION = 'IncludedEquipmentSelection';

    const packageIEKey = `${selectedPackage &&
      selectedPackage.toLowerCase()}${INCLUDED_EQUIPMENT}`;
    const packageIESKey = `${selectedPackage &&
      selectedPackage.toLowerCase()}${INCLUDED_EQUIPMENT_SELECTION}`;
    const packageAEKey = `${selectedPackage &&
      selectedPackage.toLowerCase()}${ADDITIONAL_EQUIPMENT}`;
    const includedEquipments =
      orderData[packageIEKey] &&
      Object.keys(orderData[packageIEKey])
        .map(iEKey => {
          const value = getFieldPriceOrLabel(formStepFields, iEKey, false);
          return {
            value,
            qty: orderData[packageIEKey][iEKey],
            prices: {
              monthly: 0,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          };
        })
        .filter(item => item.qty > 0);

        const calculateTempSensors = (aEKey) => {
            const equipmentSelections = orderData[aEKey];
            const sensorKeys = ['temperatureSensor', 'easyTemperatureSensor', 'easyFiveYearTemperatureSensor'];
            
            const totalSensors = sensorKeys.reduce((total, sensor) => {
              if (equipmentSelections[sensor]) {
                return total + parseInt(equipmentSelections[sensor], 10);
              }
              return total;
            }, 0);
            
            return totalSensors;
          };

  const additionalEquipments =
      orderData[packageAEKey] &&
      Object.keys(orderData[packageAEKey])
        .map(aEKey => {
          const value = getFieldPriceOrLabel(formStepFields, aEKey, false);
          let prices = getFieldPriceOrLabel(formStepFields, aEKey, true);
          const qty = parseInt(orderData[packageAEKey][aEKey], 10);
          const modeOfPaymentCondition = aEKey.startsWith('easy')
            ? aEKey.startsWith('easyFiveYear')
              ? modeOfPaymentValues.MONTHLY_FIVE_YEAR
              : modeOfPaymentValues.MONTH_TO_MONTH
            : modeOfPaymentValues.ONE_TIME;
          if (prices) {
            additionalEquipmentsTotal +=
              (prices.monthly && prices.monthly * qty) ||
              (prices.oneTime && prices.oneTime * qty) ||
              (prices.monthlyFiveYear && prices.monthlyFiveYear * qty);
            monthly += prices.monthly * qty;
            oneTime += prices.oneTime * qty;
            monthlyFiveYear += prices.monthlyFiveYear * qty;
            if (modeOfPaymentCondition === modeOfPaymentValues.MONTH_TO_MONTH) {
              prices.monthly *= qty;
            }
            if (modeOfPaymentCondition === modeOfPaymentValues.ONE_TIME) {
              prices.oneTime *= qty;
            }
            if (
              modeOfPaymentCondition === modeOfPaymentValues.MONTHLY_FIVE_YEAR
            ) {
              prices.monthlyFiveYear *= qty;
            }
          }
          // SOF-1773
         // Code here to calculate monthly service fee
         const totalSensorsCount = calculateTempSensors(packageAEKey);
         if(totalSensorsCount >0 && totalSensorsCount <= 5)
         {
            serviceFee =5;
         }
         else if(totalSensorsCount >5 && totalSensorsCount <=10)
         {
            serviceFee =10;
         }
         calculateTempSensors(packageAEKey);
          prices = prices || {
            monthly: 0,
            oneTime: 0,
            monthlyFiveYear: 0
          };
          return {
            value,
            qty,
            prices,
            modeOfPayment: modeOfPaymentCondition,
            tempServiceFee: serviceFee
          };
        })
        .filter(item => item.qty > 0);

    if (includedEquipments && includedEquipments.length)
      product.includedEquipments = includedEquipments;
    if (additionalEquipments && additionalEquipments.length)
      product.additionalEquipments = additionalEquipments;

    if (selectedPackage !== Monitor) {
      const selectedIncludedEquipments =
        orderData[packageIESKey] &&
        Object.keys(orderData[packageIESKey])
          .map(siEKey => {
            const value = getFieldPriceOrLabel(formStepFields, siEKey, false);
            let prices = getFieldPriceOrLabel(formStepFields, siEKey, true);
            const qty = parseInt(orderData[packageIESKey][siEKey], 10);
            const modeOfPaymentCondition = siEKey.startsWith('easy')
            ? siEKey.startsWith('easyFiveYear')
              ? modeOfPaymentValues.MONTHLY_FIVE_YEAR
              : modeOfPaymentValues.MONTH_TO_MONTH
            : modeOfPaymentValues.ONE_TIME;
            if (prices) {
                additionalEquipmentsTotal +=
                  (prices.monthly && prices.monthly * qty) ||
                  (prices.oneTime && prices.oneTime * qty) ||
                  (prices.monthlyFiveYear && prices.monthlyFiveYear * qty);
                monthly += prices.monthly * qty;
                oneTime += prices.oneTime * qty;
                monthlyFiveYear += prices.monthlyFiveYear * qty;
                if (modeOfPaymentCondition === modeOfPaymentValues.MONTH_TO_MONTH) {
                  prices.monthly *= qty;
                }
                if (modeOfPaymentCondition === modeOfPaymentValues.ONE_TIME) {
                  prices.oneTime *= qty;
                }
                if (
                  modeOfPaymentCondition === modeOfPaymentValues.MONTHLY_FIVE_YEAR
                ) {
                  prices.monthlyFiveYear *= qty;
                }
              }
              prices = prices || {
                monthly: 0,
                oneTime: 0,
                monthlyFiveYear: 0
              };
              return {
                value,
                qty,
                prices,
                modeOfPayment: modeOfPaymentCondition,
              };
          })
          .filter(item => item.qty > 0);
      if (selectedIncludedEquipments && selectedIncludedEquipments.length) {
        product.selectedEquipments = selectedIncludedEquipments;
      }
      if (orderData.securityPackageFeature) {
        monthly +=
          getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          ) &&
          getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          ).monthly;
        product.features.push({
          value: getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            false
          ),
          qty: 1,
          prices: getFieldPriceOrLabel(
            formStepFields,
            orderData.securityPackageFeature,
            true
          )
        });
      }
    }
    // update smart camera offers.........
    if (selectedPackage === smartCameraKey) {
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(tenOFFWireline)) {
          monthly -= 10;
          product.regularOffers.push({
            value: tenOFFWirelineTSB || tenOFFWireline,
            qty: 1,
            prices: {
              monthly: -10,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(tenOFFWireless)) {
          monthly -= 10;
          product.regularOffers.push({
            value: tenOFFWirelessTSB || tenOFFWireless,
            qty: 1,
            prices: {
              monthly: -10,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(installationOff)) {
          oneTime -= 100;
          product.regularOffers.push({
            value: installationOffTSB || installationOff,
            qty: 1,
            prices: {
              monthly: 0,
              oneTime: -100,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(zeroInstallation)) {
          oneTime -= 199;
          product.regularOffers.push({
            value: zeroInstallationTSB || zeroInstallation,
            qty: 1,
            prices: {
              monthly: 0,
              oneTime: -100,
              monthlyFiveYear: 0
            }
          });
        }
      }
      if (orderData.smartCameraOffers) {
        if (orderData.smartCameraOffers.includes(threeDollarOff)) {
          monthly -= 3;
          product.regularOffers.push({
            value: threeDollarOff,
            qty: 1,
            prices: {
              monthly: -3,
              oneTime: 0,
              monthlyFiveYear: 0
            }
          });
        }
      }
    }
    if (orderData.secureBusinessOffers) {
      const offerList = orderData.secureBusinessOffers;
      const isThreeOrSixMonthFreeIncluded =
        offerList.includes(threeMonthFree) ||
        offerList.includes(sixMonthsFree) ||
        offerList.includes(tsbSecurityOffersObject.sixMonthsFreeEn);
      if (
        offerList.includes(tenOffWirelene) ||
        offerList.includes(tenOffWireleneTSB)
      ) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 10;
        product.regularOffers.push({
          value: tenOffWirelene || tenOffWireleneTSB,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      // here
      if (offerList.includes(fivePercenDiscount)) {
        monthly -= fivePercenDiscount ? 5 : 0;
        product.regularOffers.push({
          value: fivePercenDiscount,
          qty: 1,
          prices: {
            monthly: -5,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      // if 20$ is in the list
      if (
        offerList.includes(
          tsbSecurityOffersObject.twentyDollarOffEn ||
            tsbSecurityOffersObject.twentyDollarOffFr
        )
      ) {
        monthly -= 20;
        product.regularOffers.push({
          value: tsbSecurityOffersObject.twentyDollarOffEn,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      // if 10$ is in the list
      if (offerList.includes(_tenDollarOff)) {
        monthly -= 10;
        product.regularOffers.push({
          value: _tenDollarOff,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      // here end
      if (offerList.includes(twentyOffWireline)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 20;
        product.regularOffers.push({
          value: twentyOffWirelineTSB || twentyOffWireline,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(zeroInstallation)) {
        oneTime -= selectedPackagePrice.oneTime;
        product.regularOffers.push({
          value: zeroInstallationTSB || zeroInstallation,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -selectedPackagePrice.oneTime
          }
        });
      }
      if (offerList.includes(threeMonthFree)) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: threeMonthFreeTSB || threeMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(sixMonthsFree)) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: sixMonthFreeTSB || sixMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(tsbSecurityOffersObject.sixMonthsFreeEn)) {
        monthly -= selectedPackagePrice.monthly;
        product.regularOffers.push({
          value: tsbSecurityOffersObject.sixMonthsFreeEn || sixMonthFree,
          qty: 1,
          prices: {
            monthly: -selectedPackagePrice.monthly,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(tenOffMpp)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 10;
        product.regularOffers.push({
          value: tenOffMppTSB || tenOffMpp,
          qty: 1,
          prices: {
            monthly: -10,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(twentyOffMpp)) {
        monthly -= isThreeOrSixMonthFreeIncluded ? 0 : 20;
        product.regularOffers.push({
          value: twentyOffMppTSB || twentyOffMpp,
          qty: 1,
          prices: {
            monthly: -20,
            oneTime: 0,
            monthlyFiveYear: 0
          }
        });
      }
      if (offerList.includes(hardwareCredit)) {
        const subtractedAmount =
          additionalEquipmentsTotal > 200 ? 200 : additionalEquipmentsTotal;
        oneTime -= subtractedAmount;
        product.regularOffers.push({
          value: hardwareCredit,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -subtractedAmount
          }
        });
      }
      if (offerList.includes(installationOff)) {
        oneTime -= 100;
        product.regularOffers.push({
          value: installationOffTSB || installationOff,
          qty: 1,
          prices: {
            monthly: 0,
            monthlyFiveYear: 0,
            oneTime: -100
          }
        });
      }
    }
  }
  monthly += serviceFee;
  return {
    ...product,
    totalMonthly: (monthly > 0 && Math.abs(monthly.toFixed(2))) || 0,
    totalMonthlyFiveYear:
      (monthlyFiveYear > 0 && Math.abs(monthlyFiveYear.toFixed(2))) || 0,
    totalOneTime: (oneTime > 0 && Math.abs(oneTime.toFixed(2))) || 0,
    temperatureServiceFee:
      (serviceFee > 0 && Math.abs(serviceFee.toFixed(2))) || 0
  };
};
